import React from 'react'
import { Icon, Button } from 'semantic-ui-react'

export default class CancelButton extends React.PureComponent {
  onCancelClick = () => {
    const { order, showCancelReasons } = this.props

    const hasAssignDriver = ['confirmed', 'outForDelivery','drivers_not_available'].includes(order.status)
    const isForceCancel = order.deliverer && hasAssignDriver

    showCancelReasons(isForceCancel)
  }

  render() {
    const { order, confirmingDriver, confirmingPackage, readOnly } = this.props

    return (
      <Button
        size="mini"
        onClick={this.onCancelClick}
        style={{ width: 150, margin: '5px 0px 0px 0px' }}
        disabled={confirmingDriver || confirmingPackage || order.driver_pending_order || readOnly}
      >
        <Icon name="cancel" />
        Cancel Order
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/Cancel.js